import { render, staticRenderFns } from "./k-search-user.vue?vue&type=template&id=3c2eb671&"
import script from "./k-search-user.vue?vue&type=script&lang=ts&"
export * from "./k-search-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports